import { useAuth0 } from "@auth0/auth0-react";
import { FC } from "react";
import { Link } from "react-router-dom";
import { appRoutes } from "../../../utils/routes";
import UserMenu from "../../common/UserMenu/UserMenu";
import { UnderdotsLogoHorizontalBlackGreen } from "../../common/SvgLibrary/logos/UnderdotsLogo";

type NavBarProps = {};

const NavBar: FC<NavBarProps> = () => {
  const { isAuthenticated } = useAuth0();

  return (
    <div className="w-full flex justify-between items-center p-6 max-w-5xl min-h-[96px]">
      <Link
        to={isAuthenticated ? appRoutes.PROJECTS : appRoutes.ROOT}
        className="flex gap-2 items-center"
      >
        <div className="flex flex-col items-end justify-end">
          <UnderdotsLogoHorizontalBlackGreen />
        </div>
      </Link>
      <UserMenu showIcon={false}>
        <Link
          to={appRoutes.PROJECTS}
          className="block px-4 py-2 text-sm text-gray-700"
        >
          Undermaps
        </Link>
      </UserMenu>
    </div>
  );
};

export default NavBar;
